import React from 'react';
import * as Yup from 'yup';

export const CabinetNameValidatorSchema = Yup.object().shape({
    name: Yup.string()
        .min(2, 'tooShort')
        .max(20, 'tooLong')
        .required("required")
});